import { useJobContext } from 'pages/Job/context';
import { useMemo } from 'react';
import { calculateJobTotal } from 'utils';

export interface JobFinanceBankingSubsidyHook {
  cardPayment: number;
  subsidy?: number;
  payout?: number;
}

export default function useJobFinanceBankingSubsidy(): JobFinanceBankingSubsidyHook {
  const { job, isLoading } = useJobContext();

  const total = useMemo(
    () => (job?.job_items ? calculateJobTotal(job.job_items).totalIncVat : 0),
    [job],
  );

  const deposit = useMemo(
    () =>
      job?.customer_options?.deposit_value?.amount ||
      job?.deposit_value?.amount ||
      0,
    [job],
  );

  const cardPayment = useMemo(() => total - deposit, [total, deposit]);

  const subsidy = useMemo(() => {
    if (isLoading) return undefined;
    return Math.ceil(cardPayment * 0.01);
  }, [isLoading, cardPayment]);

  const payout = useMemo(
    () => (subsidy ? cardPayment - subsidy : undefined),
    [cardPayment, subsidy],
  );

  return {
    cardPayment,
    subsidy,
    payout,
  };
}
